import { Directive, HostBinding } from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({
    selector: 'form',
    standalone: false
})
export class FormDirective {
  @HostBinding('attr.novalidate') novalidate = true;
  @HostBinding('attr.autocomplete') autocomplete = 'off';
  @HostBinding('attr.autocapitalize') autocapitalize = 'none';
}
